import { normalizeText } from './text';

// O cadastro mantém a primeira categoria nos campos legados e todos os vínculos
// em categories. Use a subcategoria do vínculo que corresponde à página atual.
export const getMaterialSubcategories = (material, categoryId, categoryName) => {
  const matches = (id, name) =>
    (Boolean(categoryId) && id === categoryId) ||
    (Boolean(categoryName) && normalizeText(name) === normalizeText(categoryName));

  const associations = (Array.isArray(material.categories) ? material.categories : [])
    .filter(category => category && matches(category.categoryId, category.categoryName));

  if (associations.length) {
    return [...new Set(associations.map(category => category.subcategory || 'Outros'))];
  }

  const legacyCategory = material.category || material.categoria;
  return matches(legacyCategory, legacyCategory)
    ? [material.subcategory || material.subcategoria || 'Outros']
    : [];
};

export const materialHasSubcategory = (material, subcategory) =>
  material.subcategory === subcategory || material.subcategoria === subcategory ||
  (Array.isArray(material.categories) && material.categories.some(category =>
    category?.subcategory === subcategory
  ));
